import React from 'react'
import Pagination2 from '../../common/Pagination2'
import ActivityListItem from './ActivityListItem'

function ActivityList({
    activityList,
    activityDate,
    activityType,
    currentPage,
    totalPages,
    paginate,
}) {
  return (
    <>
        <nav>
            <Pagination2 
              
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={paginate}
            />
        </nav>
        <table className="table table-row-gray-300 gs-2 gy-2">
            <thead>
                <tr className='fw-bolder fs-6 text-gray-800 border-bottom border-gray-200'>
                    <th className="">Id</th>
                    <th className="text-center min-w-300px">Activity</th>
                    <th className="text-center min-w-50px">Status</th>
                    <th className="text-center min-w-50px">Category</th>
                    
                    <th></th>
                </tr>
            </thead>
            <tbody>
                    {activityList.map((item,index)=>{
                    return <ActivityListItem key={index} item={item}/>
                })}
            </tbody>
        </table>
       
        <nav>
            <Pagination2 
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={paginate}
            />
        </nav>
    
    </>
  )
}

export default ActivityList